// extracted by mini-css-extract-plugin
export var chevron = "_lm-3";
export var chevronRotated = "_lm-4";
export var image = "_lm-1";
export var imageContainer = "_lm-0";
export var shippingAddress = "_lm-2";